import React from 'react'
import './bannerTitles.scss'
import { graphql, useStaticQuery } from 'gatsby'
import { GatsbyImage, getImage, withArtDirection } from 'gatsby-plugin-image'
import useMediaQuery from '../../../utils/useMediaQuery'
import ArrowScrollDown from '../../atoms/arrowScrollDown/arrowScrollDown'

const BannerTitles = ({ section }) => {
  const isMobile = useMediaQuery()

  const {
    titleMore: { childImageSharp: titleMore },
    titleAwards: { childImageSharp: titleAwards },
    titleAmbassador: { childImageSharp: titleAmbassador },
    titleChallenges: { childImageSharp: titleChallenges },
    titleMoreMob: { childImageSharp: titleMoreMOb },
    titleAwardsMob: { childImageSharp: titleAwardsMob },
    titleAmbassadorMob: { childImageSharp: titleAmbassadorMob },
    titleeChallengesMob: { childImageSharp: titleeChallengesMob },
  } = useStaticQuery(graphql`
    {
      titleMore: file(name: { eq: "title-mas-de-cur-v" }) {
        childImageSharp {
          gatsbyImageData
        }
      }
      titleAwards: file(name: { eq: "title-premios" }) {
        childImageSharp {
          gatsbyImageData
        }
      }
      titleAmbassador: file(name: { eq: "title-ser-embajadora" }) {
        childImageSharp {
          gatsbyImageData
        }
      }
      titleChallenges: file(name: { eq: "title-retos" }) {
        childImageSharp {
          gatsbyImageData
        }
      }
      titleMoreMob: file(name: { eq: "title-mas-de-cur-v-mob" }) {
        childImageSharp {
          gatsbyImageData
        }
      }
      titleAwardsMob: file(name: { eq: "title-premios-mob" }) {
        childImageSharp {
          gatsbyImageData
        }
      }
      titleAmbassadorMob: file(name: { eq: "title-ser-embajadora-mob" }) {
        childImageSharp {
          gatsbyImageData
        }
      }
      titleeChallengesMob: file(name: { eq: "title-retos-mob" }) {
        childImageSharp {
          gatsbyImageData
        }
      }
    }
  `)

  const awardsTitle = {
    more: [titleMore, titleMoreMOb],
    awards: [titleAwards, titleAwardsMob],
    ambassador: [titleAmbassador, titleAmbassadorMob],
    challenges: [titleChallenges, titleeChallengesMob],
  }

  return (
    <div className="f-banner-title">
      <div className="f-banner-title__container">
        <GatsbyImage
          objectFit="cover"
          image={getImage(awardsTitle[`${section}`][isMobile ? 1 : 0])}
          alt="Aprende Más"
          className="f-banner-title__image"
        />
      </div>
      {!isMobile && <ArrowScrollDown />}
    </div>
  )
}

export default BannerTitles
